import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Select } from './Field';
import type { Page } from '../../lib/types';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function LinkPicker({ value, onChange, placeholder = 'Selecciona un destino...' }: Props) {
  const [pages, setPages] = useState<Page[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.pages.list()
      .then(setPages)
      .finally(() => setLoading(false));
  }, []);

  // Normalize slug: ensure single leading slash
  function toHref(slug: string) {
    const s = slug.startsWith('/') ? slug : `/${slug}`;
    return s === '/index' ? '/' : s;
  }

  const options: { key: string; label: string; value: string }[] = [
    { key: '_manual', label: 'Ingresar URL manual...', value: '_manual' },
    { key: '_inicio', label: 'Inicio', value: '/' },
    ...pages.map(p => ({
      key: `page-${p.id}`,
      label: `Página: ${p.title} (${p.locale.toUpperCase()})`,
      value: toHref(p.slug),
    })),
    { key: '_propiedades', label: 'Propiedades (Archivo)', value: '/propiedades' },
    { key: '_blog', label: 'Blog (Archivo)', value: '/blog' },
  ];

  const isManual = !options.some(opt => opt.value === value && opt.value !== '_manual');
  const [showManual, setShowManual] = useState(isManual && value !== '');

  return (
    <div className="space-y-2">
      <Select
        value={showManual ? '_manual' : value}
        onChange={(e) => {
          const val = e.target.value;
          if (val === '_manual') {
            setShowManual(true);
          } else {
            setShowManual(false);
            onChange(val);
          }
        }}
      >
        <option value="" disabled>{loading ? 'Cargando páginas...' : placeholder}</option>
        {options.map(opt => (
          <option key={opt.key} value={opt.value}>{opt.label}</option>
        ))}
      </Select>

      {showManual && (
        <input
          type="text"
          value={value === '_manual' ? '' : value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://... o /ruta-custom"
          className="w-full bg-ui-bg border border-ui-border rounded px-3 py-2 text-sm text-ui-text focus:outline-none focus:border-ui-accent placeholder:text-ui-text-subtle"
        />
      )}
    </div>
  );
}
